import { heroImages, images } from './images';
import type { EquipmentCategory, EquipmentItem } from '../types/content';

export const equipmentCategories: EquipmentCategory[] = [
  { id: 'earthmoving', title: 'Earthmoving Equipment', description: 'Excavation, trenching and material handling.' },
  { id: 'road', title: 'Road Construction & Compaction', description: 'Shaping, watering and compacting road layers.' },
  { id: 'transport', title: 'Transport & Support Vehicles', description: 'Haulage, plant transport and site support.' },
  { id: 'concrete', title: 'Concrete & Construction Equipment', description: 'Mixing and placing concrete on site.' },
  { id: 'access', title: 'Access Equipment & Scaffolding', description: 'Safe access for building and structural works.' },
];

export const equipment: EquipmentItem[] = [
  {
    id: 'excavator',
    name: 'Excavator (20 ton)',
    category: 'earthmoving',
    quantity: '1',
    description: 'Tracked excavator for bulk excavation, trenching and loading.',
    image: heroImages.roads,
  },
  {
    id: 'backhoe-loader',
    name: 'TLB / JCB Backhoe Loader',
    category: 'earthmoving',
    quantity: '4',
    description: 'Backhoe loaders for trenching, service excavation, loading and general site work.',
    image: images.backhoe,
  },
  {
    id: 'grader',
    name: 'Motor Grader',
    category: 'road',
    quantity: '2',
    models: 'Bell 670D; Komatsu',
    description: 'Graders for shaping and levelling road formation, subbase and base layers.',
    image: images.roadGrader,
  },
  {
    id: 'vibro-roller',
    name: 'Compactor Vibro-Roller (12 ton)',
    category: 'road',
    quantity: '1',
    description: 'Vibratory roller for compacting fill, subbase and base layers.',
    image: heroImages.equipment,
  },
  {
    id: 'water-bowser',
    name: 'Water Bowser',
    category: 'road',
    quantity: '3',
    models: '18,000 L; 12,000 L; 10 kL',
    description: 'Water bowsers for moisture conditioning of road layers and dust suppression.',
    image: images.waterBowser,
  },
  {
    id: 'plate-compactor',
    name: 'Plate Compactor',
    category: 'road',
    quantity: '5',
    description: 'Plate compactors for trench backfill, paving bedding and confined areas.',
    image: images.plateCompactor,
  },
  {
    id: 'horse-trailer',
    name: 'Horse & Trailer Trucks',
    category: 'transport',
    quantity: '2',
    models: 'Horse and trailer tipper truck; horse and trailer low-bed crane truck',
    description: 'Tipper haulage of materials and low-bed transport of plant between sites.',
    image: images.tipperTrucks,
  },
  {
    id: 'tipper-truck',
    name: 'Tipper Truck',
    category: 'transport',
    quantity: '1',
    description: 'Rigid tipper truck for hauling materials and spoil.',
    image: images.tipperTrucks,
  },
  {
    id: 'ford-ranger',
    name: 'Ford Ranger 4x4 Double Cab',
    category: 'transport',
    quantity: '3',
    description: 'Four-wheel-drive double-cab pickups for site supervision and crew transport.',
    image: images.pickups,
  },
  {
    id: 'nissan-pickup',
    name: 'Nissan 2.5D Single Cab',
    category: 'transport',
    quantity: '3',
    description: 'Single-cab pickups for site logistics and light materials.',
    image: images.pickups,
  },
  {
    id: 'concrete-mixer',
    name: 'Concrete Mixer',
    category: 'concrete',
    quantity: '3',
    description: 'Site concrete mixers for structural and general concrete works.',
    image: images.concreteMixer,
  },
  {
    id: 'concrete-vibrator',
    name: 'Concrete Vibrator (poker units)',
    category: 'concrete',
    quantity: '2',
    description: 'Poker vibrators for consolidating freshly placed concrete.',
    image: images.concreteMixer,
  },
  {
    id: 'scaffolding',
    name: 'Scaffolding',
    category: 'access',
    quantity: '120 sets',
    description: 'Scaffolding sets for access during building and structural works.',
    image: images.scaffolding,
  },
];
